type ReadFieldFunction = (fieldName: string, object?: any) => any;
type MergeObjectsFunction = (existing: any, incoming: any) => any;

/**
 * Merge array by unique field value using a hash map for O(1) lookups
 */
export function mergeArrayByField<T>(fieldName: string) {
  return function (
    existing: T[] | undefined,
    incoming: T[] | undefined,
    { readField, mergeObjects }: { readField: ReadFieldFunction; mergeObjects: MergeObjectsFunction },
  ): T[] {
    const merged: T[] = existing ? existing.slice(0) : [];
    const fieldValueToIndex: Record<string, number> = Object.create(null);

    if (existing) {
      existing.forEach((item, index) => {
        // @ts-ignore
        const fieldValue = readField(fieldName, item) ?? item.id;
        if (fieldValue) {
          fieldValueToIndex[fieldValue] = index;
        }
      });
    }

    incoming?.forEach((item) => {
      // @ts-ignore
      const fieldValue = readField(fieldName, item) ?? item.id;

      if (!fieldValue) return;

      const existingIndex = fieldValueToIndex[fieldValue];
      if (typeof existingIndex === 'number') {
        merged[existingIndex] = mergeObjects(merged[existingIndex], item);
      } else {
        fieldValueToIndex[fieldValue] = merged.length;
        merged.push(item);
      }
    });

    return merged;
  };
}

/**
 * Merge array by unique field value in reverse order using a hash map for O(1) lookups
 */
export function mergeArrayByFieldReverse<T>(fieldName: string) {
  return function (
    existing: T[] | undefined,
    incoming: T[] | undefined,
    { readField, mergeObjects }: { readField: ReadFieldFunction; mergeObjects: MergeObjectsFunction },
  ): T[] {
    const merged: T[] = existing ? existing.slice(0) : [];
    const fieldValueToIndex: Record<string, number> = Object.create(null);
    const incomingNodes: T[] = [];

    if (existing) {
      existing.forEach((item, index) => {
        const fieldValue = readField(fieldName, item);
        if (fieldValue) {
          fieldValueToIndex[fieldValue] = index;
        }
      });
    }

    incoming?.forEach((item) => {
      const fieldValue = readField('id', item);
      if (!fieldValue) {
        // 버그 있음
        // https://github.com/apollographql/apollo-client/issues/9315

        incomingNodes.push(item);
        return;
      }

      const existingIndex = fieldValueToIndex[fieldValue];
      if (typeof existingIndex === 'number') {
        merged[existingIndex] = mergeObjects(merged[existingIndex], item);
      } else {
        incomingNodes.push(item);
      }
    });

    merged.unshift(...incomingNodes);
    return merged;
  };
}
